import styled from "styled-components";

export const DivImg = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  gap: 10px;
`;
export const H1NotFound = styled.h1`
  color: var(--letterColorWhite);
`;
